import { render, staticRenderFns } from "./AboutILP.vue?vue&type=template&id=69d15d1d&scoped=true&"
import script from "./AboutILP.vue?vue&type=script&lang=js&"
export * from "./AboutILP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d15d1d",
  null
  
)

export default component.exports